const gameJamProjects = [
	{
		title: "HOMUNCULUS",
		subtitle: "Game Designer / 3D Artist / UI Programmer",
		year: "2026",
		color: "text-purple-500",
		borderColor: "#7236d1",
		engine: "Made in Unity (C#)",
		thumbnail: "/thumbnails/homunculus-thumb.png",
		videos: [
			"videos/Homunculus/homunculus-video-1.mp4",
			"videos/Homunculus/homunculus-video-2.mp4",
			"videos/Homunculus/homunculus-video-3.mp4"
		],
		platforms: ["itch"],
		playLink: "https://glumpis.itch.io/homunculus",
		description: "Made for Brackey's Game Jam 2026.2",
		contributions: [
			"Designed and implemented every single piece of UI in the game",
			"Co-Designed core gameplay",
			"Created the map, and most 3D models",
			"Set up audio system for playing SFX",
			"Some core gameplay programming"
		]
	},

	{
		title: "THEY ARE WATCHING",
		subtitle: "Game Designer / 3D Artist / UI Programmer",
		year: "2025",
		color: "text-red-600",
		borderColor: "#8f0000ff",
		engine: "Made in Unity (C#)",
		thumbnail: "/thumbnails/watching-thumb.png",
		videos: [
			"videos/Watching/watching-1.mp4",
			"videos/Watching/watching-2.mp4",
			"videos/Watching/watching-3.mp4"
		],
		platforms: ["itch"],
		playLink: "https://glumpis.itch.io/they-are-watching",
		description: "Placed 49th out of 956 (top 5%) overall in SCREAM JAM 2025. Placed 24th out of 956 (top 2-3%) for Horror.",
		contributions: [
			"Designed and implemented every single piece of UI in the game",
			"Co-Designed core gameplay",
			"Lead most level design",
			"Designed and modelled 3D assets",
			"Some core gameplay programming"
		]
	},

	{
		title: "Pizza Blitz",
		subtitle: "Game Designer / UI Programmer",
		year: "2024",
		color: "text-orange-400",
		borderColor: "#f7aa77ff",
		engine: "Made in Unity (C#)",
		thumbnail: "/thumbnails/pizza-blitz-jam-thumb.png",
		videos: [
			"videos/PizzaBlitz/pizza-blitz-1.mp4",
			"videos/PizzaBlitz/pizza-blitz-2.mp4",
			"videos/PizzaBlitz/pizza-blitz-3.mp4"
		],
		platforms: ["itch"],
		playLink: "https://glumpis.itch.io/pizza-blitz-jam",
		description: "Hectic pizza making / delivery game. Placed 39th out of 1,502 (top 2.6%) overall in Brackey's Game Jam 2024.2",
		contributions: [
			"Designed and implemented every single piece of UI in the game",
			"Co-Designed core gameplay",
			"Lead most level design",
			"Designed and modelled 3D assets",
			"Some core gameplay programming"
		]
	},

	{
		title: "The Intruder",
		subtitle: "Game Designer / Level Design / Artist",
		year: "2023",
		color: "text-green-700",
		borderColor: "#728400",
		engine: "Made in Godot (C# / GDScript)",
		thumbnail: "/thumbnails/intruder-thumb.png",
		videos: [
			"videos/Intruder/intruder_clip_1.mp4",
			"videos/Intruder/intruder_clip_2.mp4",
			"videos/Intruder/intruder_clip_3.mp4"
		],
		platforms: ["itch"],
		playLink: "https://glumpis.itch.io/the-intruder-jam",
		description: "A short survival horror game. Made in 1 week for Scream Jam 2023",
		contributions: [
			"Designed and modelled the level",
			"Co-Designed core gameplay",
			"Audio design",
			"Designed and created 3D models",
		]
	},

	{
		title: "Grave Diver",
		subtitle: "Game Designer / UI Programmer",
		year: "2023",
		color: "text-yellow-400",
		borderColor: "#e9f549ff",
		engine: "Made in Unity (C#)",
		thumbnail: "/thumbnails/grave-diver-jam-thumb.png",
		videos: [
			"videos/GraveDiver/grave-diver-1.mp4",
			"videos/GraveDiver/grave-diver-2.mp4",
			"videos/GraveDiver/grave-diver-3.mp4"
		],
		platforms: ["itch"],
		playLink: "https://glumpis.itch.io/grave-diver-jam",
		description: "Barebones Auto-Chess style game. Made in 1 week for Brackey's Game Jam 2023.2",
		contributions: [
			"Designed and implemented every single piece of UI in the game",
			"Co-Designed  and programmed core gameplay",
			"Audio design",
			"Pixel art"
		]
	},

	{
		title: "Retail Cycle",
		subtitle: "Game Designer / UI Programmer / Gameplay Programmer",
		year: "2023",
		color: "text-pink-400",
		borderColor: "#ff92faff",
		engine: "Made in Unity (C#)",
		thumbnail: "/thumbnails/retail-cycle-thumb.png",
		videos: [
			"videos/RetailCycle/retail-cycle-1.mp4",
			"videos/RetailCycle/retail-cycle-2.mp4",
			"videos/RetailCycle/retail-cycle-3.mp4"
		],
		platforms: ["itch"],
		playLink: "https://glumpis.itch.io/retail-cycle-jam",
		description: "Wario-ware like microgame collection. Made in 2 weeks for MyFirstGameJam 2023 Summer Jam",
		contributions: [
			"Designed most of the microgames",
			"Designed and implemented all UI in the project",
			"Microgame programming",
			"3D modelling and pixel art",
			"Audio design"
		]
	},
];

export default gameJamProjects;